import React, { memo } from 'react';
import { withPopUp, IconButton, IconClose } from '@redlink/components/atoms';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { OrderItemDetail, Form } from '@redlink/components/organisms';
import { useLocale } from '@redlink/assets/locale';
import { FormSection } from '@redlink/components/molecules';
import { createUseStyle } from '@redlink/assets/styles';

export const OrderDetailPage = withPopUp(
  memo(({ onDismiss, ...rest }) => {
    const { dictionary } = useLocale();
    const { styles } = useStyle();
    return (
      <DataEntryModalTemplate>
        <Form>
          <FormSection style={styles.headerContainer}>
            <IconButton onPress={onDismiss}>
              <IconClose />
            </IconButton>
          </FormSection>
          <FormSection title={dictionary.orderDetail}>
            <OrderItemDetail {...rest} />
          </FormSection>
        </Form>
      </DataEntryModalTemplate>
    );
  })
);

const useStyle = createUseStyle(({ colors, size }) => ({
  headerContainer: {
    alignItems: 'flex-end',
  },
}));
